import { defineMessages } from 'react-intl';

type MessageKeys = 'leadInText' | 'hardwareLinkLabel';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	leadInText: {
		id: 'conversation-assistant-message-actions.controllers.ham-onboarding-hardware-link.leadInText',
		defaultMessage: 'Follow this link to start managing your hardware:',
		description: 'Introductory text shown above the link to the hardware management page',
	},
	hardwareLinkLabel: {
		id: 'conversation-assistant-message-actions.controllers.ham-onboarding-hardware-link.hardwareLinkLabel',
		defaultMessage: 'Jira Service Management: Hardware',
		description: 'Label for the link that navigates the user to the hardware management page',
	},
});
